import { type CrmRelationsParticuliereRelationDto as ParticuliereRelatieDto } from '@services/crm-public/orval-api/model/crmRelationsParticuliereRelationDto';
import { type CrmRelationsZakelijkeRelationDto as ZakelijkeRelatieDto } from '@services/crm-public/orval-api/model/crmRelationsZakelijkeRelationDto';
import { type CrmRelationsRelationDto as RelatieDto } from '@services/crm-public/orval-api/model/crmRelationsRelationDto';
import { SUREbusinessCommonDomainRelatiesSoortRelatieEnum as SoortRelatie } from '@services/crm-public/orval-api/model/sUREbusinessCommonDomainRelatiesSoortRelatieEnum';

export function isZakelijkeRelatieDto(relatie: RelatieDto): relatie is ZakelijkeRelatieDto {
  return relatie?.typeName === SoortRelatie.Z;
}

export function isParticuliereRelatieDto(relatie: RelatieDto): relatie is ParticuliereRelatieDto {
  return relatie?.typeName === SoortRelatie.P;
}

export type RelatiegegevensTab =
  | 'algemeen'
  | 'schades'
  | 'incasso'
  | 'documenten'
  | 'prolongatiewijzigingen'
  | 'memos';

export const relatiegegevensTabs: Record<RelatiegegevensTab, string> = {
  algemeen: '#general',
  schades: '#claims',
  incasso: '#payment',
  documenten: '#documents',
  prolongatiewijzigingen: '#prolwijz',
  memos: '#memos',
};
